import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mockArticles } from '@/mocks/articles';

interface Props {
  categorySlug: string;
}

export default function CategoryGrid({ categorySlug }: Props) {
  const { t } = useTranslation();
  const articles = mockArticles.filter((a) => a.category === categorySlug);

  const subtitleText =
    {
      'star-scandal': t('category_starScandal_subtitle'),
      'influencer-gossip': t('category_influencerGossip_subtitle'),
      'black-material': t('category_blackMaterial_subtitle'),
    }[categorySlug] || '';

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100/70">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">{subtitleText}</h2>
        </div>

        {articles.length === 0 ? (
          <p className="text-center text-foreground-500 py-10">暂无相关文章，敬请期待~</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {articles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group block rounded-2xl border border-background-300/60 bg-background-50 overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              >
                <div className="relative w-full aspect-[16/10] overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 line-clamp-2 mb-2">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-600 line-clamp-2 mb-3">{article.excerpt}</p>
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span>{article.date}</span>
                    <span>{article.views} 阅读</span>
                    <span>{article.comments} 评论</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}